import React from 'react';
import {connect} from 'react-redux';

import LanguageItem from './LanguageItem';

const LanguageMenu = props => {
    if (props.isLanguageMenuOpen && props.configuration.languages && props.configuration.languages.length > 1) {
        return (
            <div id="languageMenu">
                <ul>
                    {props.configuration.languages.map(language => {
                        if (language.code !== props.currentLanguage.code) {
                            return <LanguageItem key={language.code} className={`flag`} title={language.title}
                                                 language={language} languageCode={language.code}/>
                        } else {
                            return null;
                        }
                    })}
                </ul>
            </div>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => {
    return {...state};
};

export default connect(mapStateToProps)(LanguageMenu);